<section class="container">
    <figure class="image-container">
        <section class="loader-container">
            <section class="loader">
                <img class="logo" [ngSrc]="'modak-circle-logo.svg' | staticServe" width="64" height="64" alt="" />
                <ng-lottie class="mdk-lottie" [options]="lottieConfig" />
                <img class="logo" [ngSrc]="'plaid_circle_logo.svg' | staticServe" width="64" height="64" alt="" />
            </section>
        </section>

        <h2 class="subtitle" [mdkChangeTextWithColorAndImage]="'KYC.SUBMITTED_PAGE.TITLE' | translate">
        </h2>
    </figure>

    <section class="messages-container" *ngIf="dataAfterMinutes.description && dataAfterMinutes.iconSrc">
        <div class="icon-container" *ngIf="dataAfterMinutes.iconSrc">
            <span class="image-element">{{ renderEmoji() }}</span>
        </div>
        <p class="description">{{dataAfterMinutes.description}}</p>
    </section>
</section>
